module.exports = __webpack_public_path__ + "assets/img/306201.5303bc46.png";